import Detail from "./details.container";

export default Detail;
